// extracted by mini-css-extract-plugin
export default {"footerEmail":"footeremail_footerEmail__zrBUR","emailInput":"footeremail_emailInput__HY+Fq"};